import { useTranslation } from 'react-i18next';

import { EmptyW, StyledText } from './styled';

export const EmptyState = () => {
  const { t } = useTranslation();
  return (
    <EmptyW>
      <StyledText>{t('document.list.emptyFiles')}</StyledText>
    </EmptyW>
  );
};
